import { Button, Group, NumberInput, Textarea } from '@mantine/core';

import { Fields, useAIPromptTemplateForm } from '../hooks/useAIPromptTemplateForm';

type Props = {
  isLoading: boolean;
  onSubmit: (params: { aiId: number; template: string }) => void;
  initialValues: Fields;
  submitLabel: string;
};

export const AIPromptTemplateForm = ({
  isLoading,
  onSubmit,
  initialValues,
  submitLabel,
}: Props) => {
  const form = useAIPromptTemplateForm({ initialValues });

  return (
    <form
      onSubmit={form.onSubmit(({ aiId, template }) =>
        onSubmit({
          aiId: Number(aiId),
          template,
        })
      )}
    >
      <NumberInput
        label="AI ID"
        hideControls
        withAsterisk
        value={form.values.aiId}
        onChange={(value) => form.setFieldValue('aiId', Number(value))}
        mb="md"
        error={form.errors.aiId}
      />
      <Textarea
        label="Prompt Template"
        placeholder="Template with ###user_msg### and ###relevant_context###"
        withAsterisk
        minRows={10}
        autosize
        mb="md"
        {...form.getInputProps('template')}
      />
      <Group justify="flex-end" mt="md">
        <Button loading={isLoading} type="submit" disabled={isLoading}>
          {submitLabel}
        </Button>
      </Group>
    </form>
  );
};
